.container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.controls {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.controls > button.arrowButton {
  background-color: transparent;
}

.collapsedControls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.labelList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.25rem;
}

.labelButton {
  background: transparent;
  border: none;
  color: var(--color-link);
  cursor: pointer;
  padding: 0 0.375rem;
  text-decoration: none;
  font-size: var(--font-size-normal);
  color: var(--color-text);
  &:hover {
    text-decoration: underline;
  }
}

.labelButtonActive {
  font-weight: bold;
}

.iconWide {
  display: inline-flex;
}

.iconNarrow {
  display: none;
}

@media (max-width: 640px) {
  .controls {
    flex-direction: column;
    align-items: stretch;
    flex-wrap: nowrap;
  }

  .labelList,
  .collapsedControls {
    flex-direction: column;
    align-items: stretch;
  }

  .labelButton {
    text-align: left;
    padding: 0.5rem 0.375rem;
  }

  .iconWide {
    display: none;
  }

  .iconNarrow {
    display: inline-flex;
  }
}
